var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-wrapper"},[(_vm.isElectron)?_c('AxTitleBar'):_vm._e(),_c('div',{class:_vm.classes,attrs:{"id":"app"}},[_c('AppView'),_c('PortalTarget',{attrs:{"name":"tooltips-area"}})],1),_c('AxAppFailure',{attrs:{"error":_vm.navigationError}}),(_vm.appConfigured)?_c('AxVersionTracker'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }